export default [
  {
    path: "/forthehorde",
    name: "Testing Page",
    component: () => import("@/app/modules/testing/pages/testing.vue"),
  },
];
